import React, { useEffect, useRef, useState } from "react";
import "./About.css";
import { Link } from "react-router-dom";
import Aboutimage from "../../Asset/About.png";
import HrishImage from "../../Asset/harishImage.jpg";
import VikasImage from "../../Asset/vikasImage.jpg";
import rishabh from "../../data/PS_IMG/rishabh_dev_sahu.jpeg"
import Jitendra from "../../data/PS_IMG/jitendra_sahu.png"
import Namesh from "../../data/PS_IMG/namesh_dadsena.jpeg"
import chandni from "../../data/PS_IMG/chandani_chaturvedi.jpeg"

/* ── Why-Choose-Us feature cards data ── */
const WHY_FEATURES = [
  {
    icon: "🚀",
    title: "Innovation First",
    desc: "We ship ideas that move fast and scale smart — built around your business goals.",
    tags: ["AI-Powered", "Modern Stack"],
    color: "#E8571A",
  },
  {
    icon: "🔒",
    title: "Secure by Design",
    desc: "Security isn't an afterthought — every product is hardened from the ground up.",
    tags: ["Encrypted", "Compliant"],
    color: "#E8571A",
  },
  {
    icon: "📐",
    title: "Precision Delivery",
    desc: "On time, on spec. We're obsessive about quality so you never have to be.",
    tags: ["Agile", "QA Tested"],
    color: "#E8571A",
  },
  {
    icon: "🤝",
    title: "Long-Term Partner",
    desc: "We stay long after launch — supporting, iterating, and growing with you.",
    tags: ["Support 24/7", "Scalable"],
    color: "#E8571A",
  },
];

/* ── Stats data ── */
const STATS = [
  { num: "100+", label: "Projects Delivered", icon: "🎯" },
  { num: "500+", label: "Trained Interns", icon: "😊" },
  { num: "4+", label: "Years Experience", icon: "⭐" },
  { num: "24/7", label: "Support Available", icon: "🛟" },
];

/* ── Leadership data (DARK SECTION) ── */
const LEADERS = [
  {
    name: "Vikas Yadu",
    role: "Director & CTO",
    img: VikasImage,
    bio: "Leads and manages technology projects, focusing on project planning, development, team coordination, and delivering practical solutions that meet business and client requirements.",
    experience: "5+ Years Experience",
    expertise:
      "Project Management, Project Planning, Technology Strategy & Team Coordination",
    mentoring:
      "Guides students and trainees through real-world projects, helping them understand project requirements, development workflows, planning, and industry practices.",
    tags: [
      "Project Management",
      "Project Guidance",
      "Innovation",
      "Project Planning",
      "Support",
      "Team Coordination",
      "Mentoring",
    ],
    social: {
      linkedin: "https://www.linkedin.com/in/vikas-yadu-6bba92221/",
      email: "mailto:vikasyadu2603@gmail.com",
    },
  },
  {
    name: "Harish Sen",
    role: "Founder & CEO",
    img: HrishImage,
    bio: "Leads technical training and development classes, helping students and professionals build strong programming fundamentals, practical skills, and industry-ready knowledge.",
    experience: "5+ Years Experience",
    expertise: "Software Architecture, Full Stack Development, Cloud Solutions & Backend Engineering",
    mentoring: "Helps trainees gain hands-on experience through real-world projects, modern development practices, and practical problem-solving.",
    tags: [
      "Technical Training",
      "Full Stack",
      "Programming",
      "Practical Learning",
      "Career Guidance",
      "Problem Solving",
      "Mentoring",
    ],
    social: {
      linkedin: "https://www.linkedin.com/in/harish-sen-b29164250/",
      email: "mailto:harishsen0609@gmail.com",
    },
  },
];

/* ── Team Members data (LIGHT SECTION) ── */
const TEAM_MEMBERS = [
  {
    name: "Rishabh Dev Sahu",
    role: "Data Analytics",
    img: rishabh,
  },
  {
    name: "Jitendra Sahu",
    role: "Senior Software Developer",
    img: Jitendra,
  },
  {
    name: "Namesh Kumar Dadsena",
    role: "FullStack and App Developer",
    img: Namesh,
  },
  {
    name: "Chandni Chaturvedi",
    role: "FullStack Developer",
    img: chandni,
  },
];

/* ── Values data ── */
const VALUES = [
  { icon: "💡", title: "Innovation", desc: "Pushing boundaries with fresh ideas" },
  { icon: "🎯", title: "Excellence", desc: "Delivering nothing but the best" },
  { icon: "🤝", title: "Integrity", desc: "Honest & transparent partnerships" },
  { icon: "🌱", title: "Growth", desc: "Continuous learning & evolution" },
];

/* ── Animated Counter Hook ── */
function useCounter(end, duration = 2000, start = 0) {
  const [count, setCount] = useState(start);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIsVisible(true),
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    const numericEnd = parseInt(end);
    if (isNaN(numericEnd)) return;
    let startTime;
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * numericEnd));
      if (progress < 1) requestAnimationFrame(animate);
    };
    requestAnimationFrame(animate);
  }, [isVisible, end, duration]);

  return { count, ref };
}

/* ── Stat Counter Component ── */
function StatCounter({ stat }) {
  const { count, ref } = useCounter(stat.num);
  const suffix = stat.num.replace(/[0-9]/g, "");
  return (
    <div className="stat-card" ref={ref}>
      <div className="stat-icon">{stat.icon}</div>
      <div className="stat-number">
        {isNaN(parseInt(stat.num)) ? stat.num : `${count}${suffix}`}
      </div>
      <div className="stat-label">{stat.label}</div>
    </div>
  );
}

export default function About() {
  return (
    <section className="about-page" id="about">

      {/* ══════════════════════════════════════
          SECTION 1 — HERO (DARK)
      ══════════════════════════════════════ */}
      <div className="about-hero section-dark">
        <div className="hero-bg-grid"></div>
        <div className="hero-glow hero-glow-1"></div>
        <div className="hero-glow hero-glow-2"></div>

        <div className="about-inner">
          {/* Left: Image */}
          <div className="about-img-wrap">
            <div className="img-frame-decor img-frame-tl"></div>
            <div className="img-frame-decor img-frame-br"></div>
            <div className="about-img-container">
              <img
                src={Aboutimage}
                alt="Yashvi Tech Team"
                className="about-img"
              />
              <div className="img-overlay-gradient"></div>
            </div>

            <div className="floating-badge badge-top">
              <div className="badge-icon">🏆</div>
              <div>
                <div className="badge-num">100+</div>
                <div className="badge-txt">Projects Shipped</div>
              </div>
            </div>

            <div className="floating-badge badge-bottom">
              <div className="badge-dots">
                <span></span><span></span><span></span>
              </div>
              <div>
                <div className="badge-num">Live</div>
                <div className="badge-txt">Building Since 2023</div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="about-text">
            <span className="exp-eyebrow">
              <span className="eyebrow-dot"></span>
              About YashviTech
            </span>

            <h2 className="about-heading">
              Crafting Digital <br />
              <span className="title-orange">Experiences That Matter</span>
            </h2>

            <p className="about-para">
              YashviTech is a leading IT solutions company focused on building{" "}
              <strong>modern websites</strong>, software, <strong>AI solutions</strong>{" "}
              and mobile applications that help businesses grow faster through technology.
            </p>

            <p className="about-para">
              Our team combines innovation, quality and performance to create{" "}
              <strong>secure, scalable</strong> and user-friendly digital products
              that deliver real business value.
            </p>

            <div className="about-tags">
              {["Web Apps", "Mobile", "AI Solutions", "Cloud", "DevOps"].map((t) => (
                <span key={t} className="kf-tag">{t}</span>
              ))}
            </div>

            <div className="about-cta-row">
              <Link to="/contact" className="btn-primary">
                Start a Project <span>→</span>
              </Link>
              <Link to="/services" className="btn-ghost">
                Our Services
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════
          SECTION 2 — WHY CHOOSE US (LIGHT)
      ══════════════════════════════════════ */}
      <div className="why-sec section-light">
        <div className="light-bg-pattern"></div>

        <div className="exp-header">
          <p className="exp-eyebrow">
            <span className="eyebrow-dot"></span>
            Why Choose Us
          </p>
          <p className="exp-subtitle">
            Four pillars that separate YashviTech from every other agency on the market.
          </p>
        </div>

        <div className="why-grid">
          {WHY_FEATURES?.map((f, i) => (
            <div
              className="why-card"
              key={f.title}
              style={{ "--accent": f.color, animationDelay: `${i * 0.1}s` }}
            >
              <div className="why-card-glow"></div>
              <div className="why-icon-wrap">
                <span className="why-icon">{f.icon}</span>
                <div className="why-icon-ring"></div>
              </div>
              <div className="why-number">0{i + 1}</div>

              <h3 className="why-title">{f.title}</h3>
              <p className="why-desc">{f.desc}</p>

              <div className="why-tags">
                {f.tags?.map((t) => (
                  <span key={t} className="why-tag">{t}</span>
                ))}
              </div>


            </div>
          ))}
        </div>
      </div>

      {/* ══════════════════════════════════════
          SECTION 3 — LEADERSHIP (DARK)
      ══════════════════════════════════════ */}
      <div className="leadership-sec section-dark">
        <div className="dark-bg-blob dark-blob-1"></div>

        <div className="exp-header">
          <p className="exp-eyebrow">
            <span className="eyebrow-dot"></span>
            Our Leadership
          </p>
          <p className="exp-subtitle">
            Our leadership team combines innovation, experience, and vision to
            deliver world-class digital solutions.
          </p>
        </div>

        <div className="leaders-grid">
          {LEADERS?.map((l, i) => (
            <div className="leader-card" key={l.name} style={{ animationDelay: `${i * 0.15}s` }}>
              <div className="leader-img-wrap">
                <div className="leader-img-bg"></div>
                <img src={l.img} alt={l.name} className="leader-img" />
                <div className="leader-social">
                  <a href={l.social?.linkedin} aria-label="LinkedIn">in</a>
                  {/* <a href={l.social?.twitter} aria-label="Twitter">𝕏</a> */}
                  <a href={l.social?.email} aria-label="Email">✉</a>
                </div>
              </div>

              <div className="leader-content">
                <span className="leader-role-badge">{l.role}</span>
                <h3 className="leader-name">{l.name}</h3>
                <p className="leader-bio">{l.bio}</p>

                <div className="leader-tags">
                  {l.tags?.map((t) => (
                    <span key={t} className="kf-tag">{t}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ══════════════════════════════════════
          SECTION 4 — OUR TEAM MEMBERS (LIGHT)
      ══════════════════════════════════════ */}
      <div className="team-members-sec section-light">
        <div className="light-bg-pattern"></div>

        <div className="exp-header">
          <p className="exp-eyebrow">
            <span className="eyebrow-dot"></span>
            Our Team
          </p>
          <p>Learn from experienced mentors, work on real-world projects, and gain the practical skills you need to build a successful career in technology.</p>
        </div>

        <div className="team-grid">
          {TEAM_MEMBERS?.map((m, i) => (
            <div className="team-card-v2" key={m.name} style={{ animationDelay: `${i * 0.1}s` }}>

              {/* Photo Area with Light Pattern & Hover Overlay */}
              <div className="team-img-wrapper">
                <div className="team-img-border-decor"></div>
                <img src={m.img} alt={m.name} className="team-member-img" />
              </div>

              {/* Card Body Details */}
              <div className="team-details">
                <span className="team-member-role">{m.role}</span>
                <h3 className="team-member-name">{m.name}</h3>
              </div>

            </div>
          ))}
        </div>
      </div>

    </section>
  );
}